<template>
  <div>
    <div class="w-100" id="ticket-custom">
      <!-- HEADER -->
      <CustomHeader :step="view_type"></CustomHeader>
    </div>
    <div class="container my-5">
      <div class="row">
        <!-- SELECT TICKET -->
        <div class="col-12 col-lg-7 mb-5">
          <p class="text-heading-t text-primary-t font-hw">{{ view_type == 1 ? $t('ticket.select-ticket') : $t('ticket.select-payment-method') }}</p>
          <div class="w-100 radius-12 p-4 bg-white box-shadow-light-aff border-secondary-t">
            <!-- STEP 1 -->
            <template v-if="view_type == 1">
              <div class="d-block w-100" id="ticket-section"></div>
              <div class="mb-4 w-100">
                <div class="mb-4 border-b-dashed-secondary-t pb-4">
                  <div class="row slim-grid-row">
                    <div class="col-12">
                      <date-range-picker 
                        class="w-100 calendar-ticket-wrapper" 
                        ref="date" 
                        :min-date="min_date" 
                        v-model="visit_date"
                        opens="right" 
                        :show-dropdowns="false" 
                        :ranges="false" 
                        :single-date-picker="true" 
                        auto-apply>
                        <template v-slot:input="picker">
                          <div class="w-100 border-primary-t radius-6 py-2 px-2 box-shadow-light-aff">
                            <div class="row no-gutters">
                              <div class="col-8 col-lg-9 text-left align-self-center no-ws">
                                <div class="d-inline-block align-middle mr-3">
                                  <svg width="29" height="27" viewBox="0 0 29 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.53195 26.6H24.2474C27.2638 26.6 28.7649 25.0989 28.7649 22.1257V4.50307C28.7649 1.52989 27.2638 0.0288544 24.2474 0.0288544H4.53195C1.51546 0.0288544 0 1.51545 0 4.50307V22.1257C0 25.1133 1.51546 26.6 4.53195 26.6ZM4.31546 24.2762C3.03092 24.2762 2.32371 23.5979 2.32371 22.2556V8.64533C2.32371 7.3175 3.03092 6.62472 4.31546 6.62472H24.4349C25.7195 6.62472 26.4412 7.3175 26.4412 8.64533V22.2556C26.4412 23.5979 25.7195 24.2762 24.4349 24.2762H4.31546ZM11.5752 11.8062H12.4267C12.9319 11.8062 13.0907 11.6618 13.0907 11.1567V10.3051C13.0907 9.79997 12.9319 9.6412 12.4267 9.6412H11.5752C11.0701 9.6412 10.8969 9.79997 10.8969 10.3051V11.1567C10.8969 11.6618 11.0701 11.8062 11.5752 11.8062ZM16.367 11.8062H17.2186C17.7236 11.8062 17.8968 11.6618 17.8968 11.1567V10.3051C17.8968 9.79997 17.7236 9.6412 17.2186 9.6412H16.367C15.8618 9.6412 15.6887 9.79997 15.6887 10.3051V11.1567C15.6887 11.6618 15.8618 11.8062 16.367 11.8062ZM21.1587 11.8062H22.0103C22.5154 11.8062 22.6886 11.6618 22.6886 11.1567V10.3051C22.6886 9.79997 22.5154 9.6412 22.0103 9.6412H21.1587C20.6535 9.6412 20.4948 9.79997 20.4948 10.3051V11.1567C20.4948 11.6618 20.6535 11.8062 21.1587 11.8062ZM6.78349 16.5258H7.6206C8.1402 16.5258 8.29895 16.3814 8.29895 15.8762V15.0247C8.29895 14.5196 8.1402 14.3752 7.6206 14.3752H6.78349C6.26391 14.3752 6.10514 14.5196 6.10514 15.0247V15.8762C6.10514 16.3814 6.26391 16.5258 6.78349 16.5258ZM11.5752 16.5258H12.4267C12.9319 16.5258 13.0907 16.3814 13.0907 15.8762V15.0247C13.0907 14.5196 12.9319 14.3752 12.4267 14.3752H11.5752C11.0701 14.3752 10.8969 14.5196 10.8969 15.0247V15.8762C10.8969 16.3814 11.0701 16.5258 11.5752 16.5258ZM16.367 16.5258H17.2186C17.7236 16.5258 17.8968 16.3814 17.8968 15.8762V15.0247C17.8968 14.5196 17.7236 14.3752 17.2186 14.3752H16.367C15.8618 14.3752 15.6887 14.5196 15.6887 15.0247V15.8762C15.6887 16.3814 15.8618 16.5258 16.367 16.5258ZM21.1587 16.5258H22.0103C22.5154 16.5258 22.6886 16.3814 22.6886 15.8762V15.0247C22.6886 14.5196 22.5154 14.3752 22.0103 14.3752H21.1587C20.6535 14.3752 20.4948 14.5196 20.4948 15.0247V15.8762C20.4948 16.3814 20.6535 16.5258 21.1587 16.5258ZM6.78349 21.2597H7.6206C8.1402 21.2597 8.29895 21.101 8.29895 20.5959V19.7442C8.29895 19.2391 8.1402 19.0948 7.6206 19.0948H6.78349C6.26391 19.0948 6.10514 19.2391 6.10514 19.7442V20.5959C6.10514 21.101 6.26391 21.2597 6.78349 21.2597ZM11.5752 21.2597H12.4267C12.9319 21.2597 13.0907 21.101 13.0907 20.5959V19.7442C13.0907 19.2391 12.9319 19.0948 12.4267 19.0948H11.5752C11.0701 19.0948 10.8969 19.2391 10.8969 19.7442V20.5959C10.8969 21.101 11.0701 21.2597 11.5752 21.2597ZM16.367 21.2597H17.2186C17.7236 21.2597 17.8968 21.101 17.8968 20.5959V19.7442C17.8968 19.2391 17.7236 19.0948 17.2186 19.0948H16.367C15.8618 19.0948 15.6887 19.2391 15.6887 19.7442V20.5959C15.6887 21.101 15.8618 21.2597 16.367 21.2597Z" class="fill-primary-t"/>
                                  </svg>
                                </div>
                                <div class="d-inline-block align-middle">
                                  <p class="overline mb-0 text-uppercase">{{ $t('ticket.visit-date') }}</p>
                                  <p class="text-16 text-primary-t font-hw mb-0">{{ $formatDate(visit_date.startDate) }}</p>
                                </div>
                              </div>
                              <div class="col-4 col-lg-3 text-right align-self-center">
                                <button class="g-btn g-btn-primary-ticket g-btn-sm w-100">{{ $t('ticket.change-date') }}</button>
                              </div>
                            </div>
                          </div>
                        </template>
                        <template #date="data">
                          <div class="calendar-ticket-item">
                            <p class="text-14 font-lato mb-0">
                              {{ formatDateNumber(data.date) }}
                            </p>
                          </div>
                        </template>
                      </date-range-picker>
                    </div>
                    <!-- <div class="col-12">
                      <p class="text-heading-t text-secondary-t font-hw text-left mb-0">Ticket options</p>
                    </div> -->
                  </div>
                </div>
                <b-skeleton-wrapper :loading="is_load">
                  <template #loading>
                    <div class="mb-4" v-for="i in 2">
                      <b-skeleton width="30%" height="30px" class="mb-2"></b-skeleton>
                      <div class="w-100 mb-2" v-for="j in 2">
                        <b-skeleton width="75%" height="60px" class="d-inline-block align-middle mr-2"></b-skeleton>
                        <b-skeleton width="20%" height="20px" class="d-inline-block align-middle"></b-skeleton>
                      </div>
                    </div>
                  </template>

                  <div class="w-100 mb-4">
                    <!-- <p class="text-24 text-secondary-t font-hw text-left mb-3">Ticket Options</p> -->
                    <div class="w-100" v-for="(item, index) in list" :class="index + 1 < list.length ? 'mb-4' : 'mb-3'">
                      <div class="row mb-2">
                        <div class="col-8 col-lg-9">
                          <div class="row">
                            <div class="col-7 col-sm-9 align-self-center">
                              <p class="mb-0 font-hw text-18 text-ticket">{{ item.name }}</p>
                            </div>
                            <div class="col-5 col-sm-3 align-self-center text-right">
                              <button class="g-btn g-btn-primary-ticket g-btn-sm w-100" @click="toggleProductDetail(item)">{{ $t('ticket.detail') }}</button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3" v-for="(variant, var_i) in item.variants">
                        <div class="col-8 col-lg-9 align-self-center">
                          <div class="w-100 border-secondary-t radius-6"
                            :class="{
                              'bg-custom-light': variant.availability == 0,
                              'bg-white': variant.availability > 0 && variant.qty == 0,
                              'bg-light-primary-ticket': variant.qty > 0
                            }">
                            <div class="row no-gutters">
                              <div class="col-7 col-lg-9 align-self-center">
                                <div class="w-100 pl-3">
                                  <p class="body-2-1 mb-0" v-for="pax in variant.pax">
                                    {{ pax.qty > 1 ? `${pax.qty} ` : '' }}{{ pax.name }}</p>
                                </div>
                              </div>
                              <div class="col-2 col-lg-1 align-self-center">
                                <div class="text-center py-1 border-x-secondary-t w-100">
                                  <div class="w-100 mb-1 cursor-pointer" @click="changeQty(index, var_i, 'plus')">
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <path d="M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z" fill="black" fill-opacity="0.54" />
                                    </svg>
                                  </div>
                                  <div class="w-100 mt-1 cursor-pointer" @click="changeQty(index, var_i, 'minus')">
                                    <svg width="14" height="2" viewBox="0 0 14 2" fill="none"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <path d="M14 2H0V0H14V2Z" fill="black" fill-opacity="0.54" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                              <div class="col-3 col-lg-2 align-self-center text-center">
                                <p class="heading-5-2 font-lato mb-0 text-ticket">{{ variant.qty }}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-4 col-lg-3 align-self-center">
                          <p class="body-3-3-1 font-lato mb-0 text-line-through" v-if="variant.best_price.best_price.promotion != null">{{ $formatCurrency(variant.best_price.price_sell) }}</p>
                          <p class="body-2-4 font-lato mb-0 d-md-block d-none">{{ $formatCurrency(variant.best_price.best_price.final_price) }}/{{$t('ticket.pax')}}</p>
                          <p class="body-2-4 font-lato mb-0 d-block  d-md-none">{{ $formatCurrency(variant.best_price.best_price.final_price) }}<br>/{{$t('ticket.pax')}}</p>
                          <p class="body-3 text-danger mb-0" v-if="variant.availability == 0">{{ $t('ticket.not-available') }}</p>
                        </div>
                      </div>
                    </div>
                    <p class="mb-0 body-3-3-1 text-left">{{ $t('ticket.free-for-infant') }}</p>
                  </div>
                  <div class="w-100 pt-5 border-t-dashed-secondary-t" v-if="product_special.list.length > 0">
                    <div class="w-100 position-relative">
                      <!-- <p class="text-secondary-t font-hw text-left mb-2 text-heading-t">Where are you from?</p> -->
                      <p class="overline position-absolute text-danger cursor-pointer text-uppercase" v-if="product_special.selected.id && showSelectionProductSpecial"
                        style="top:-30px;left: 0px" @click="toggleProductSpecial()">{{ $t('ticket.cancel-selection') }}</p>
                      <div class="w-100 py-2 radius-6 mb-3 cursor-pointer" v-for="(ps,ps_i) in product_special.list"
                        @click="toggleProductSpecial(ps)"
                        :class="ps.id == product_special.selected.id ? 'border-primary-t bg-light-primary-ticket' : 'border-secondary-t'">
                        <div class="row no-gutters">
                          <div class="col-lg-1 col-2 align-self-center" v-if="showSelectionProductSpecial">
                            <div class="radio-ticket mx-auto d-table">
                              <div class="active" v-if="ps.id == product_special.selected.id"></div>
                            </div>
                          </div>
                          <div class="align-self-center" :class="showSelectionProductSpecial ? 'col-lg-9 col-7' : 'col-lg-10 col-9'">
                            <div :class="!showSelectionProductSpecial ? 'pl-3' : ''">
                              <p class="mb-0 body-2-4 text-ticket">{{ ps.name }}</p>
                              <div class="body-3-3-1 html-desc" v-html="ps.description"></div>
                            </div>
                          </div>
                          <div class="col-lg-2 col-3 align-self-center" >
                            <div class="px-3 text-right">
                              <img v-if="!$isImageNull(ps.image_url)" class="w-75" :src="ps.image_url">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-skeleton-wrapper>
              </div>
            </template>
            <!-- STEP 2 -->
            <template v-else>
              <div class="w-100">
                <b-skeleton-wrapper :loading="payment_method.is_load">
                  <template #loading>
                    <div class="w-100 py-3 radius-6 mb-3 border-secondary-t" v-for="j in 2">
                      <div class="row no-gutters">
                        <div class="col-md-1 col-2 align-self-start">
                          <b-skeleton type="avatar" height="22px" width="22px" class="d-table mx-auto"></b-skeleton>
                        </div>
                        <div class="col-md-9 col-8 align-self-start">
                          <div class="px-3">
                            <b-skeleton width="50%" height="25px" class="mb-2"></b-skeleton>
                            <b-skeleton width="80%" height="18px" class="mb-1"></b-skeleton>
                            <b-skeleton width="60%" height="18px" class="mb-1"></b-skeleton>
                          </div>
                        </div>
                        <div class="col-md-2 col-2 align-self-start">
                          <div class="pr-3">
                            <b-skeleton width="100%" height="52px" class="mb-1"></b-skeleton>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>

                  <div class="w-100">
                    <div class="w-100 py-3 radius-6 mb-3 cursor-pointer" v-for="(pm, index) in payment_method.list" :class="pm.id == payment_method.selected.id ? 'border-primary-t bg-light-primary-ticket' : 'border-secondary-t'">
                      <div class="row no-gutters" @click="selectPayment(pm)">
                        <div class="col-md-1 col-2 align-self-start">
                          <div class="radio-ticket mx-auto d-table">
                            <div class="active" v-if="pm.id == payment_method.selected.id"></div>
                          </div>
                        </div>
                        <div class="col-md-9 col-8 align-self-start">
                          <div class="px-3">
                            <p class="mb-0 body-2-4 text-ticket">{{ pm.name }}</p>
                            <!-- <p class="mb-0 body-3-3-1 html-desc text-truncate-inside" v-if="pm.id != payment_method.selected.id"
                              style="height: 21px;overflow:hidden" v-html="pm.description"></p>
                            <p class="mb-0 body-3-3-1" v-else v-html="pm.description"></p> -->
                            <p class="mb-0 body-3-3-1" :class="pm.id == payment_method.selected.id? '' : 'text-truncate-2'" v-html="pm.description"></p>
                          </div>
                        </div>
                        <div class="col-md-2 col-2 align-self-start">
                          <div class="pr-3">
                            <img :src="pm.image_url" style="max-width: 100%;height: 52px;object-fit:contain;">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-skeleton-wrapper>
              </div>
            </template>
          </div>
        </div>

        <!-- PURCHASE SUMMARY -->
        <div id="purchase-summary" class="col-12 col-lg-5 mb-5 pb-4">
          <div class="sticky" style="top: 20px">
            <p class="text-heading-t text-primary-t font-hw">{{ $t('ticket.purchase-summary') }}</p>
            <div class="w-100 radius-12 p-4 bg-white box-shadow-light-aff border-secondary-t">
              <div class="mb-4 pb-4 border-b-dashed-primary-t" v-if="selected_product.length > 0">
                <div class="row slim-grid-row" v-for="(selected_prd,i) in selected_product" :class="{'mb-3': i+1 < selected_product.length}">
                  <div class="col-8">
                    <p class="mb-0 font-hw text-18 text-ticket">{{selected_prd.name}}</p>
                    <div class="d-flex align-items-center" v-for="selected_vr in selected_prd.variants">
                      <p class="body-2-1 mb-0">{{printVariantSelected(selected_vr)}}</p>
                      <svg class="ml-2" style="margin-top: -2px;" v-if="$isNotEmptyV2(selected_vr.message)" :id="`warning-${selected_vr.id}`" v-b-tooltip.hover.v-warning.auto :title="selected_vr.message" width="20" height="18" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M12.2812 0.5C13.1869 0.500016 14.0602 0.949031 14.5771 1.85352L14.5781 1.85449L23.6719 17.6982C23.9265 18.1473 24.0625 18.6365 24.0625 19.0898C24.0625 19.8736 23.8001 20.5378 23.3506 21.0029C22.9038 21.4651 22.2386 21.7656 21.3633 21.7656H3.19922C2.32395 21.7656 1.65867 21.4651 1.21191 21.0029C0.76236 20.5378 0.50001 19.8736 0.5 19.0898C0.5 18.6261 0.617815 18.1526 0.885742 17.7061L0.890625 17.6982L9.98438 1.85449L9.9873 1.84961C10.4911 0.950947 11.3728 0.5 12.2812 0.5Z"
                          fill="#FFF0E0" stroke="#FFC69E" />
                        <path
                          d="M12.293 14.4375C11.6836 14.4375 11.3438 14.0859 11.332 13.4648L11.1797 7.08984C11.168 6.46875 11.625 6.02344 12.2812 6.02344C12.9141 6.02344 13.4062 6.48047 13.3945 7.10156L13.2188 13.4648C13.207 14.0977 12.8672 14.4375 12.293 14.4375ZM12.293 18.3633C11.5898 18.3633 10.9805 17.8008 10.9805 17.1094C10.9805 16.4062 11.5781 15.8438 12.293 15.8438C12.9961 15.8438 13.5938 16.3945 13.5938 17.1094C13.5938 17.8125 12.9844 18.3633 12.293 18.3633Z"
                          fill="#FF6F00" />
                      </svg>
                    </div>
                  </div>
                  <div class="col-4 text-right">
                    <p class="text-16 font-lato mb-0">{{ printTotalPriceSelected(selected_prd) }}</p>
                    <div v-if="view_type == 1" class="d-table ml-auto cursor-pointer" @click="removeQty(selected_prd)">
                      <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_201_6878)">
                          <path
                            d="M4.41081 12.7934C4.15135 12.7934 3.98503 12.6403 3.97172 12.3875L3.77214 5.06279C3.76549 4.81663 3.93181 4.65696 4.19792 4.65696C4.44407 4.65696 4.61705 4.80998 4.6237 5.05613L4.83659 12.3875C4.84324 12.6337 4.67027 12.7934 4.41081 12.7934ZM6.43994 12.7934C6.18045 12.7934 6.00082 12.6337 6.00082 12.3875V5.06279C6.00082 4.81663 6.18045 4.65696 6.43994 4.65696C6.69939 4.65696 6.88565 4.81663 6.88565 5.06279V12.3875C6.88565 12.6337 6.69939 12.7934 6.43994 12.7934ZM8.47568 12.7934C8.21624 12.7934 8.04326 12.6337 8.0499 12.3875L8.25615 5.06279C8.26279 4.80998 8.43577 4.65696 8.68193 4.65696C8.94801 4.65696 9.11435 4.81663 9.10771 5.06279L8.9081 12.3875C8.89482 12.6403 8.72848 12.7934 8.47568 12.7934ZM3.51934 3.04033H4.57713V1.61663C4.57713 1.23742 4.84324 0.991266 5.24241 0.991266H7.62412C8.02328 0.991266 8.28942 1.23742 8.28942 1.61663V3.04033H9.34717V1.5501C9.34717 0.585447 8.72184 0 7.6973 0H5.16923C4.1447 0 3.51934 0.585447 3.51934 1.5501V3.04033ZM0.49896 3.57256H12.3875C12.6603 3.57256 12.8798 3.33971 12.8798 3.06694C12.8798 2.79418 12.6603 2.56798 12.3875 2.56798H0.49896C0.232848 2.56798 0 2.79418 0 3.06694C0 3.34636 0.232848 3.57256 0.49896 3.57256ZM3.39293 14.8158H9.49358C10.4449 14.8158 11.0836 14.1971 11.1302 13.2457L11.5959 3.43285H1.28399L1.75634 13.2524C1.80291 14.2037 2.42827 14.8158 3.39293 14.8158Z"
                            fill="#DC3545" />
                        </g>
                        <defs>
                          <clipPath id="clip0_201_6878">
                            <rect width="12.8798" height="16" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mb-4 pb-4 border-b-dashed-primary-t" v-if="view_type == 1">
                <div class="row slim-grid-row">
                  <div class="col-12">
                    <p class="text-16 text-secondary-t font-hw mb-1">{{ $t('ticket.enter-promo-code') }}</p>
                  </div>
                  <div class="col-7">
                    <div class="w-100 border-secondary-t radius-6 position-relative" :class="promo_code.error != '' ? 'shake-el border-danger' : ''" style="padding-block: 12.3px;">
                      <input :disabled="promo_code.is_load" type="text" class="w-100 no-focus-border border-none body-1-4 radius-6 text-ticket pl-3 pr-5" v-model="promo_code.form" @keyup.enter="$refs.btn_promo.handleClick()">
                      <div v-if="promo_code.form != ''" class="position-absolute cursor-pointer" @click="clearPromoCode" style="top: 10px;right:10px;">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M0.221622 13.3683C0.521384 13.6596 1.01813 13.6596 1.30933 13.3683L6.7907 7.88694L12.2721 13.3683C12.5633 13.6596 13.0686 13.6681 13.3598 13.3683C13.651 13.0686 13.651 12.5804 13.3598 12.2892L7.87841 6.79924L13.3598 1.31787C13.651 1.02667 13.6596 0.529924 13.3598 0.238726C13.06 -0.0610364 12.5633 -0.0610364 12.2721 0.238726L6.7907 5.7201L1.30933 0.238726C1.01813 -0.0610364 0.512819 -0.069601 0.221622 0.238726C-0.0695761 0.538488 -0.0695761 1.02667 0.221622 1.31787L5.70299 6.79924L0.221622 12.2892C-0.0695761 12.5804 -0.078141 13.0771 0.221622 13.3683Z"
                            fill="#777777" />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div class="col-5">
                    <state-button ref="btn_promo" variant="primary-ticket" block :click="applyPromo" size="lg"><span class="text-uppercase">{{ $t('ticket.apply') }}</span></state-button>
                  </div>
                  <div v-if="promo_code.error != ''" class="col-12 mt-1">
                    <p class="body-3-3 mb-0 text-danger">{{promo_code.error}}</p>
                  </div>
                </div>
              </div>
              <div class="w-100">
                <div class="row mb-3">
                  <div class="col-7">
                    <p class="body-1 mb-0 text-ticket">{{ $t('ticket.subtotal') }}</p>
                  </div>
                  <div class="col-5 text-right">
                    <p class="body-1 mb-0 text-ticket text-lato">{{ $formatCurrency(sub_total) }}</p>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-7">
                    <p class="body-1 mb-0 text-ticket">{{ $t('ticket.discount') }}</p>
                  </div>
                  <div class="col-5 text-right">
                    <p class="body-1 mb-0 text-ticket text-lato">{{ $formatCurrency(discount) }}</p>
                  </div>
                </div>
                <div class="row mb-3" v-if="payment_surcharge > 0">
                  <div class="col-7">
                    <p class="body-1 mb-0 text-ticket">{{ $t('ticket.payment-surcharge') }}</p>
                  </div>
                  <div class="col-5 text-right">
                    <p class="body-1 mb-0 text-ticket text-lato">{{ $formatCurrency(payment_surcharge) }}</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-7">
                    <p class="body-1 mb-0 text-ticket font-extrabold">{{ $t('ticket.total') }}</p>
                  </div>
                  <div class="col-5 text-right">
                    <p class="body-1 mb-0 text-ticket font-extrabold">{{ $formatCurrency(total) }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- GUEST INFORMATION -->
        <div class="col-12 mb-5" v-if="view_type == 1">
          <p class="text-heading-t text-primary-t font-hw">{{ $t('ticket.guest-information') }}</p>
          <div class="w-100 radius-12 px-4 pt-4 bg-white box-shadow-light-aff border-secondary-t">
            <div class="row">
              <div class="col-lg-4 col-md-12 mb-4">
                <div class="w-100" :key="guestFormKey">
                  <v-select id="form_title" class="w-100 border-secondary-t radius-6 w-100 position-relative floating-input-label v-select" :class="{'border-danger':validation.prefix != ''}" :clearable="false" :options="prefix" v-model="guest.prefix">
                    <template #search="{ attributes, events }">
                      <label class="v-select-label">{{ $t('ticket.title') }}</label>
                      <input
                        class="vs__search w-100 no-focus-border border-none body-1-4 radius-6 text-ticket px-0"
                        @focus="floatLabel('form_title','focus')" @blur="floatLabel('form_title','blur');saveGuestData('prefix')"
                        v-bind="attributes"
                        v-on="events"
                      />
                    </template>
                    <template #option="props">
                      <p class="mb-0 body-2-4 text-ticket py-1">{{ $capitalize(props.label) }}</p>
                    </template>
                    <template #selected-option="props">
                      {{ $capitalize(props.label) }}
                    </template>
                  </v-select>
                  <p class="body-3-3 text-danger mb-0 mt-1" v-if="validation.prefix != ''">{{ validation.prefix }}</p>
                </div>
              </div>
              <div class="col-lg-4 col-sm-6 mb-4">
                <div id="form_first_name" class="w-100 border-secondary-t radius-6 w-100 position-relative floating-input-label" :class="{'border-danger':validation.first_name != '','active': validation.first_name == '' && guest.first_name != ''}">
                  <label>{{ $t('ticket.first-name') }} <span class="font-weight-bold text-danger">*</span></label>
                  <input type="text" class="w-100 no-focus-border border-none body-1-4 radius-6 text-ticket" v-model="guest.first_name" @focus="floatLabel('form_first_name','focus')" @blur="floatLabel('form_first_name','blur');saveGuestData('first_name')">
                </div>
                <p class="body-3-3 text-danger mb-0 mt-1" v-if="validation.first_name != ''">{{ validation.first_name }}</p>
              </div>
              <div class="col-lg-4 col-sm-6 mb-4" :key="guestFormKey">
                <div id="form_last_name" class="w-100 border-secondary-t radius-6 w-100 position-relative floating-input-label">
                  <label>{{ $t('ticket.last-name') }}</label>
                  <input type="text" class="w-100 no-focus-border border-none body-1-4 radius-6 text-ticket" v-model="guest.last_name" @focus="floatLabel('form_last_name','focus')" @blur="floatLabel('form_last_name','blur');saveGuestData('last_name')">
                </div>
              </div>
              <div class="col-lg-4 col-md-6 mb-4">
                <div id="form_email" class="w-100 border-secondary-t radius-6 w-100 position-relative floating-input-label" :class="{'border-danger':validation.email != '','active': validation.email == '' && guest.email != ''}">
                  <label>{{ $t('ticket.email') }} <span class="font-weight-bold text-danger">*</span></label>
                  <input type="email" class="w-100 no-focus-border border-none body-1-4 radius-6 text-ticket" v-model="guest.email" @focus="floatLabel('form_email','focus')" @blur="floatLabel('form_email','blur');saveGuestData('email')">
                </div>
                <p class="body-3-3 text-danger mb-0 mt-1" v-if="validation.email != ''">{{ validation.email }}</p>
              </div>
              <div class="col-lg-4 col-md-6 mb-4">
                <div id="form_phone" class="w-100 border-secondary-t radius-6 w-100 position-relative floating-input-label" :class="{'border-danger':validation.phone != '','active': guest.phone != ''}">
                  <label>{{ $t('ticket.phone-number') }}</label>
                  <input type="text" class="w-100 no-focus-border border-none body-1-4 radius-6 text-ticket" v-model="guest.phone" @focus="floatLabel('form_phone','focus')" @blur="floatLabel('form_phone','blur');saveGuestData('phone')">
                </div>
                <p class="body-3-3 text-danger mb-0 mt-1" v-if="validation.phone != ''">{{ validation.phone }}</p>
              </div>
              <div class="col-lg-4 col-md-12 mb-4">
                <div class="w-100">
                  <v-select 
                    id="form_country" 
                    class="w-100 border-secondary-t radius-6 w-100 position-relative floating-input-label v-select" 
                    :class="{'border-danger':validation.country != ''}" 
                    :clearable="false" 
                    :options="country" 
                    v-model="guest.country" 
                    label="name" 
                    :disabled="lock_form_guest.country">
                    <template #search="{ attributes, events }">
                      <label class="v-select-label" :class="{'active': guest.country.code}">{{ $t('ticket.country') }} <span class="font-weight-bold text-danger">*</span></label>
                      <input
                        class="vs__search w-100 no-focus-border border-none body-1-4 radius-6 text-ticket px-0"
                        :class="{'d-none': lock_form_guest.country}"
                        @focus="floatLabel('form_country','focus')" @blur="floatLabel('form_country','blur')"
                        v-bind="attributes"
                        v-on="events"
                      />
                    </template>
                    <template #option="props">
                      <p class="mb-0 body-2-4 text-ticket py-1">{{ props.name }}</p>
                    </template>
                  </v-select>
                  <p class="body-3-3 text-danger mb-0 mt-1" v-if="validation.country != ''">{{ validation.country }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 text-center mb-5 pb-5">
          <div class="d-table mx-auto mb-4" v-if="error_push != ''">
            <ErrorMessage :message="error_push" />
          </div>
          <state-button variant="secondary" size="xl" :click="submitForm" :disabled="selected_product.length == 0"><span class="text-uppercase">{{ submitButtonText }}</span></state-button>
        </div>
      </div>

      <!-- PRODUCT DETAIL -->
		  <popup-detail 
				id_ref="product_detail"
	    	direction="bottom" 
	    	:show="product_detail.show"
	    	use_max_size
	    	wrapper_size="mobile"
	    	@close="toggleProductDetail">
	    	<template v-slot:body>
	    		<div v-if="product_detail.data.id">
            <div class="w-100 position-relative" style="height:270px;">
              <img :src="product_detail.data.cover_image_url" class="img-fit radius-12-t" />
              <div class="bg-white rounded-circle position-absolute border-semi-grey cursor-pointer" style="display:inline-flex;padding:10px; right:10px;top:10px;" @click="toggleProductDetail()">
                <img src="../../../assets/img/icon/close.png" width="14" />
              </div>
            </div>
            <div class="p-4">
              <div class="w-100 mb-4">
                <p class="mb-1 font-hw text-20 text-ticket">{{ product_detail.data.name }}</p>
                <div class="html-desc body-2-2" v-html="product_detail.data.description"></div>
              </div>
              <div v-if="$isNotEmpty(product_detail.data.product_detail)" class="rounded-6 mb-4 border-secondary-t bg-white box-shadow-light-aff p-4">
                <div class="row no-gutters" v-b-toggle.product_detail>
                  <div class="col-10 align-self-center">
                    <p class="mb-0 body-1-4 text-ticket">{{ $t('ticket.product-detail') }}</p>
                  </div>
                  <div class="col-2 align-self-center text-right">
                    <svg width="23" height="14" viewBox="0 0 23 14" fill="none" xmlns="http://www.w3.org/2000/svg" style="vertical-align: none !important;">
                      <path
                        d="M11.4235 14C11.7521 14 12.0807 13.8685 12.3043 13.6187L22.4789 3.19435C22.7023 2.97088 22.8338 2.68167 22.8338 2.35304C22.8338 1.66947 22.321 1.14365 21.6375 1.14365C21.3089 1.14365 21.0066 1.2751 20.783 1.48543L10.7136 11.7784H12.1202L2.05069 1.48543C1.84037 1.2751 1.53802 1.14365 1.19625 1.14365C0.512674 1.14365 0 1.66947 0 2.35304C0 2.68167 0.131456 2.97088 0.354928 3.2075L10.5296 13.6187C10.7793 13.8685 11.0817 14 11.4235 14Z"
                        class="fill-text-t" />
                    </svg>
                  </div>
                </div>
                <b-collapse :visible="$isNotEmpty(product_detail.data.product_detail) && product_detail.show_collapse" id="product_detail" class="border-t-dashed-secondary-t pt-4 mt-4">
                  <p class="mb-0 body-2-2 html-desc" v-html="product_detail.data.product_detail"></p>
                </b-collapse>
              </div>
              <div v-if="$isNotEmpty(product_detail.data.cancellation_policy)" class="rounded-6 mb-4 border-secondary-t bg-white box-shadow-light-aff p-4">
                <div class="row no-gutters" v-b-toggle.cancellation_policy>
                  <div class="col-10 align-self-center">
                    <p class="mb-0 body-1-4 text-ticket">{{ $t('ticket.cancellation-policy') }}</p>
                  </div>
                  <div class="col-2 align-self-center text-right">
                    <svg width="23" height="14" viewBox="0 0 23 14" fill="none" xmlns="http://www.w3.org/2000/svg" style="vertical-align: none !important;">
                      <path
                        d="M11.4235 14C11.7521 14 12.0807 13.8685 12.3043 13.6187L22.4789 3.19435C22.7023 2.97088 22.8338 2.68167 22.8338 2.35304C22.8338 1.66947 22.321 1.14365 21.6375 1.14365C21.3089 1.14365 21.0066 1.2751 20.783 1.48543L10.7136 11.7784H12.1202L2.05069 1.48543C1.84037 1.2751 1.53802 1.14365 1.19625 1.14365C0.512674 1.14365 0 1.66947 0 2.35304C0 2.68167 0.131456 2.97088 0.354928 3.2075L10.5296 13.6187C10.7793 13.8685 11.0817 14 11.4235 14Z"
                        class="fill-text-t" />
                    </svg>
                  </div>
                </div>
                <b-collapse :visible="$isNotEmpty(product_detail.data.cancellation_policy) && product_detail.show_collapse" id="cancellation_policy" class="border-t-dashed-secondary-t pt-4 mt-4">
                  <p class="mb-0 body-2-2 html-desc" v-html="product_detail.data.cancellation_policy"></p>
                </b-collapse>
              </div>
              <div v-if="$isNotEmpty(product_detail.data.terms_conditions)" class="rounded-6 mb-4 border-secondary-t bg-white box-shadow-light-aff p-4">
                <div class="row no-gutters" v-b-toggle.terms_conditions>
                  <div class="col-10 align-self-center">
                    <p class="mb-0 body-1-4 text-ticket">{{ $t('ticket.terms-and-conditions') }}</p>
                  </div>
                  <div class="col-2 align-self-center text-right">
                    <svg width="23" height="14" viewBox="0 0 23 14" fill="none" xmlns="http://www.w3.org/2000/svg" style="vertical-align: none !important;">
                      <path
                        d="M11.4235 14C11.7521 14 12.0807 13.8685 12.3043 13.6187L22.4789 3.19435C22.7023 2.97088 22.8338 2.68167 22.8338 2.35304C22.8338 1.66947 22.321 1.14365 21.6375 1.14365C21.3089 1.14365 21.0066 1.2751 20.783 1.48543L10.7136 11.7784H12.1202L2.05069 1.48543C1.84037 1.2751 1.53802 1.14365 1.19625 1.14365C0.512674 1.14365 0 1.66947 0 2.35304C0 2.68167 0.131456 2.97088 0.354928 3.2075L10.5296 13.6187C10.7793 13.8685 11.0817 14 11.4235 14Z"
                        class="fill-text-t" />
                    </svg>
                  </div>
                </div>
                <b-collapse :visible="$isNotEmpty(product_detail.data.terms_conditions) && product_detail.show_collapse" id="terms_conditions" class="border-t-dashed-secondary-t pt-4 mt-4">
                  <p class="mb-0 body-2-2 html-desc" v-html="product_detail.data.terms_conditions"></p>
                </b-collapse>
              </div>
              <div v-if="$isNotEmpty(product_detail.data.how_to_redeem)" class="rounded-6 mb-4 border-secondary-t bg-white box-shadow-light-aff p-4">
                <div class="row no-gutters" v-b-toggle.how_to_redeem>
                  <div class="col-10 align-self-center">
                    <p class="mb-0 body-1-4 text-ticket">{{ $t('ticket.how-to-redeem') }}</p>
                  </div>
                  <div class="col-2 align-self-center text-right">
                    <svg width="23" height="14" viewBox="0 0 23 14" fill="none" xmlns="http://www.w3.org/2000/svg" style="vertical-align: none !important;">
                      <path
                        d="M11.4235 14C11.7521 14 12.0807 13.8685 12.3043 13.6187L22.4789 3.19435C22.7023 2.97088 22.8338 2.68167 22.8338 2.35304C22.8338 1.66947 22.321 1.14365 21.6375 1.14365C21.3089 1.14365 21.0066 1.2751 20.783 1.48543L10.7136 11.7784H12.1202L2.05069 1.48543C1.84037 1.2751 1.53802 1.14365 1.19625 1.14365C0.512674 1.14365 0 1.66947 0 2.35304C0 2.68167 0.131456 2.97088 0.354928 3.2075L10.5296 13.6187C10.7793 13.8685 11.0817 14 11.4235 14Z"
                        class="fill-text-t" />
                    </svg>
                  </div>
                </div>
                <b-collapse :visible="$isNotEmpty(product_detail.data.how_to_redeem) && product_detail.show_collapse" id="how_to_redeem" class="border-t-dashed-secondary-t pt-4 mt-4">
                  <p class="mb-0 body-2-2 html-desc" v-html="product_detail.data.how_to_redeem"></p>
                </b-collapse>
              </div>
            </div>
          </div>
	    	</template>
	    	<!-- <template v-slot:footer>
		    	<div class="p-4">
		    		<button 
              @click="toggleProductDetail()"
              class="mt-2 g-btn g-btn-secondary-ticket g-btn-lg w-100" >
              {{ $t('ticket.close-detail') }}
            </button>
					</div>
		    </template> -->
	    </popup-detail>
    </div>
    <div class="w-100">
      <!-- FOOTER -->
      <CustomFooter></CustomFooter>
    </div>

    <b-modal 
      size="lg"
      centered
      hide-footer
      hide-header
      class="p-4 bg-white border-secondary-t"
      v-model="showVisitorTypeModal"
      body-class="p-0"
      no-close-on-backdrop>
      <div class="py-4 px-3 px-lg-4 py-lg-5 radius-12 visitor-type" :style="{ backgroundImage: `url(${ZooBG})` }" style="background-size: cover; background-repeat: no-repeat;">
        <p class="text-heading-t text-primary-t font-hw mb-4 mb-lg-5 w-100 text-center">Where are you from?</p>
        <div class="container mb-3 mb-lg-5">
          <div class="row">
            <div class="col-12 col-lg-6 cursor-pointer" :class="{
              'mb-4 mb-lg-0' : vstTypeIndex == 0
            }" v-for="(vstType,vstTypeIndex) in visitorType.list" @click="selectVisitorType(vstType)">
              <div class="w-100 border-secondary-t box-shadow-light-aff radius-6 py-4 px-3" :class="vstType.id === visitorType.selected.id ? 'bg-light-primary-ticket' : 'bg-white'">
                <div class="w-100 d-flex align-items-center mb-3">
                  <div class="radio-ticket mr-3 flex-shrink-0">
                    <div class="active" v-if="vstType.id === visitorType.selected.id"></div>
                  </div>
                  <div class="w-100">
                    <p class="mb-0 font-hw text-ticket title-item">{{ vstType.title }}</p>
                  </div>
                </div>
                <div class="w-100 d-flex" v-for="(note,noteIndex) in vstType.notes" :class="{'mb-3' : noteIndex + 1 < vstType.notes.length}">
                  <span class="mr-3 body-1-4">-</span>
                  <p class="mb-0 subtitle-item">{{ note }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="w-100 text-center">
          <state-button variant="primary-ticket" :disabled="$isEmpty(visitorType.selected)" :click="submitVisitorType" size="lg">Continue</state-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import moment from 'moment'
  import country from "@/data/country"
  import { validationMixin } from "vuelidate";
  const { email,required } = require("vuelidate/lib/validators");
  import {get,post} from '@/services/index.js'
  import { resolveOrderTrackingFields } from '@/utils/tracker.js'
  import { mapGetters,mapMutations } from 'vuex';
  import DateRangePicker from 'vue2-daterange-picker';
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
  import CustomHeader from '../../../components/ticket/CustomHeader';
  import CustomFooter from '../../../components/ticket/CustomFooter';
  import { parsePhoneNumberFromString } from 'libphonenumber-js'
  import ZooBG from '@/assets/img/content/bali-bird-park-bg.jpg';
  
  export default {
    components:{
      DateRangePicker,
      CustomHeader,
      CustomFooter
    },
    data() {
      return {
        is_load: true,
        error: '',
        error_push: '',
        view_type: 1,
        stepper: [
          {id: 1, title: 'Select Ticket'},
          {id: 2, title: 'Payment Method'},
          {id: 3, title: 'Complete'},
        ],
        country: country,
        prefix: ["MR", "MRS", "MISS", "MS"],
        list: [],
        product_detail:{
          show: false,
          data: {},
          show_collapse: false
        },
        promo_code:{
          form: '',
          error: '',
          is_load: false,
          valid: ''
        },
        use_region_promo: false,
        guest:{
          first_name: '',
          last_name: '',
          email: '',
          phone: '',
          prefix: '',
          country: {}
        },
        guestFormKey: 0,
        lock_form_guest:{
          country: false
        },
        validation:{
          first_name: '',
          email: '',
          visit_date: '',
          phone: '',
          country: '',
          prefix: ''
        },
        payment_method:{
          selected: {},
          list: [],
          is_load: true
        },
        visit_date: {
          startDate: moment().toDate(),
	        endDate: moment().toDate()
        },
        min_date: moment().toDate(),
        product_special: {
          list: [],
          selected:{}
        },
        tx_inquiry: {},
        tx_payment: {},
        showVisitorTypeModal: false,
        visitorType:{
          list: [
            {
              id:"domestic",
              title: "Tamu Domestik / Domestic Guest", 
              notes: [
                'Harga khusus untuk Warga Negara Indonesia. Harap menunjukkan KTP atau Kartu Pelajar saat check-in.', 
                'Special rate for Indonesian citizens. Please present a valid KTP or Student Card upon check-in.'
              ]
            },
            {
              id:"international",
              title: "Tamu Internasional / International Guest", 
              notes: [
                'Untuk pemegang Paspor Asing atau KITAS. Harap menunjukkan Paspor atau KITAS saat check-in.', 
                'For foreign passport or KITAS holders. Please present your Passport or KITAS upon check-in.'
              ]
            }
          ],
          selected: {}
        },
        ZooBG: ZooBG
      }
    },
    mixins: [validationMixin],
    validations:{
      guest:{
        prefix: { required },
        first_name: { required },
        email: { required, email },
        phone: { required },
        country: { required }
      }
    },
    computed:{
      ...mapGetters(['getMerchant', 'getTicketTransactionResult', 'getTicketCart']),
      selected_product(){
        this.$root.$emit('bv::hide::tooltip');
        let allProducts = this.$deepCopy(this.list)
  
        
        let selectedProduct = allProducts.filter(product=>{
          const selectedVariant = product.variants.filter(variant => variant.qty > 0);
          product.variants = selectedVariant
          if(this.$isNotEmptyV2(selectedVariant)) return product
        })
        
        
        if(this.$isNotEmptyV2(selectedProduct)){
          const selectedVariants = selectedProduct.flatMap(product => product.variants);
          
          selectedProduct = selectedProduct.map(product => {
            product.variants = product.variants.map(variant => {
              variant.message = "";

              const { use_requires_another_variant, requires_another_variant } = variant;
              if(use_requires_another_variant && this.$isNotEmptyV2(requires_another_variant)){
                let requiredOther = this.$deepCopy(requires_another_variant);
                requiredOther = requiredOther.filter(reqVariant => {
                  const selectedVariant = selectedVariants.find(v => v.id === reqVariant.reference_id);
                  if(!(selectedVariant && selectedVariant.qty >= reqVariant.qty)) return reqVariant;
                })
                
                if(this.$isNotEmptyV2(requiredOther)){
                  variant.message = `${variant.variant_name} needs `
                  
                  const requiredTexts = requiredOther.map(rv => `${rv.qty} ${rv.variant_name} - ${rv.product_name}`);

                  let textList = "";
                  if(requiredTexts.length === 1) {
                    textList = requiredTexts;
                  } else if(requiredTexts.length === 2) {
                    textList = `${requiredTexts[0]} and ${requiredTexts[1]}` 
                  } else {
                    const last = requiredTexts.pop();
                    textList = `${requiredTexts.join(', ')} and ${last}`
                  }

                  variant.message += textList;
                  setTimeout(() => {
                    this.$root.$emit('bv::show::tooltip', `warning-${variant.id}`);
                  }, 1000);
                }
              }
              
              return variant;
            }) 
            return product;
          });
        }
        
        setTimeout(() => {
          this.$root.$emit('bv::hide::tooltip');
        }, 3000);
        
        return selectedProduct
      },
      sub_total(){
        let total = 0
        this.selected_product.forEach(x => {
          x.variants.forEach(y => {
            if(y.qty > 0){
              total += (y.qty * y.best_price.price_sell)
            }
          })
        });
        return total
      },
      discount(){
        let total = 0
        this.selected_product.forEach(x => {
          x.variants.forEach(y => {
            if(y.qty > 0 && y.best_price.best_price.promotion != null){
              total += (y.qty * Math.abs(y.best_price.best_price.promotion_price))
            }
          })
        });
        return total
      },
      payment_surcharge(){
				let total = 0
        let final_price = this.sub_total - this.discount
				if(this.payment_method.selected.id){
					if(this.payment_method.selected.surcharge_type == 'PERCENT'){
						total = (final_price/100)*this.payment_method.selected.surcharge_value
					}else{
						total = this.payment_method.selected.surcharge_value
					}

          if(this.payment_method.selected.bank_name == 'XENDIT' && this.payment_method.selected.payment_method == 'CREDIT_CARD') {
            total = Math.ceil(total)
          }
				}

				return total
			},
      total(){
        return this.sub_total - this.discount + this.payment_surcharge
      },
      form_valid(){
        let return_data = {
          prefix: this.$v.guest.prefix.$invalid,
          first_name: this.$v.guest.first_name.$invalid,
          email: this.$v.guest.email.$invalid,
          phone: this.$v.guest.phone.$invalid,
          country: this.$v.guest.country.$invalid,
        }
        return return_data
      },
      visit_date_start(){
        return this.$formatDate(this.visit_date.startDate)
      },
      btn_promo_code_valid(){
        return this.promo_code.form != '' && this.promo_code.valid == ''
      },
      promo_code_valid(){
        return this.discount > 0 ? this.promo_code.form : ''
      },
      ticketTrackingProps(){
        return {
          visit_date: moment(this.visit_date.startDate).format('YYYY-MM-DD'),
          promo_code: this.promo_code_valid || undefined
        }
      },
      submitButtonText(){
        if(this.total === 0) return this.$t('general.book-now');
        return this.view_type === 1 ? this.$t('general.proceed-to-payment') : this.$t('ticket.payment');
      },
      showSelectionProductSpecial(){
        return this.product_special.list.length > 1;
      },
      visitorTypeQuery(){
        const url = new URL(window.location.href);
        const params = url.searchParams;
        
        const visitorType = params.has("visitor_type") ? params.get("visitor_type") : "international";
        return visitorType;
      }
    },
    watch:{
      form_valid:{
        deep: true,
        handler() {
          if(!this.form_valid.prefix) this.validation.prefix = ''
          if(!this.form_valid.first_name) this.validation.first_name = ''
          if(!this.form_valid.email) this.validation.email = ''
          if(!this.form_valid.country) this.validation.country = ''
        }
      },
      visit_date_start(){
        if(!this.is_load){
          this.loadFirstData(true)
        }
      }
    },
    mounted(){
      const url = new URL(window.location.href);
      const params = url.searchParams;
      if(params.has("visitor_type")){
        const currentVisitorType = params.get("visitor_type");
        const isCurrentTypeValid = this.visitorType.list.findIndex(type => type.id === currentVisitorType);
        if(isCurrentTypeValid == -1){
          params.delete('visitor_type');
          window.history.replaceState({}, '', url.pathname);
          this.showVisitorTypeModal = true;
        }else{
          this.selectVisitorType(this.visitorType.list[isCurrentTypeValid]);
          this.loadFirstData();
        }
      }else{
        this.showVisitorTypeModal = true;
      }
      // this.loadFirstData()
      this.$track('page_view', this.ticketTrackingProps, { pageType: 'cart' })
    },
    methods:{
      // GENERAL
      ...mapMutations(['setTicketTransactionResult', 'resetTicketTransactionResult', 'ticketSetGuest']),
      formatDateNumber(value){
	      return moment(value).format("D")
	    },
      formatDateStandart(value){
	      return moment(value).format("DD MMM YYYY")
	    },
      changeStep(step){
        this.view_type = step
        this.$smoothScroll('ticket-custom')
      },
      setVisitorTypeUrl(type){
        const url = new URL(window.location.href);
        const params = url.searchParams;
        
        params.set('visitor_type', type);
        const newUrl = `${url.pathname}?${params.toString()}`;
        window.history.replaceState({}, '', newUrl);
      },
      selectVisitorType(type){
        this.visitorType.selected = type
      },
      async submitVisitorType(){
        try {
          this.setVisitorTypeUrl(this.visitorType.selected.id);
          await this.loadFirstData();
        } catch (error) {
          console.log("ERROR submitVisitorType : ", error.message);
        } finally { 
          this.showVisitorTypeModal = false;
          return Promise.resolve(); 
        }
      },
      
      // STEP 1
      async loadFirstData(product_list_only = false) {
        this.is_load = true
        this.error = ''

        try {
          const { inquiry, selectedProduct, promotion } = this.getTicketTransactionResult;
          const isPaymentStep = this.$isNotEmptyV2(inquiry) && this.$isNotEmptyV2(selectedProduct)
          const routeName = this.$route.name;
          if(isPaymentStep && routeName === 'TicketSelectPayment'){
            this.changeStep(2)
            await this.loadPaymentMethod()
            this.list = this.$deepCopy(selectedProduct);
            if(this.$isNotEmptyV2(promotion)) this.promo_code = promotion;
            this.tx_inquiry = inquiry
            this.visit_date.startDate = moment(inquiry.visit_date, 'YYYY-MM-DD');
            this.visit_date.endDate = moment(inquiry.visit_date, 'YYYY-MM-DD');
            
            this.checkVisitorType(inquiry);
            
          }else{
            this.loadSavedGuestData()
            this.resetTicketTransactionResult();
            await this.loadProductList()  
            if (product_list_only) this.$smoothScroll('ticket-section');
            else await this.loadProductSpecial();
          }

        } catch (err) {
          this.error = err
        } finally {
          if (product_list_only) setTimeout(() => this.is_load = false, 400) 
          else this.is_load = false
        }
      },
      loadSavedGuestData(){
        const { 
          title: prefix,
          first_name = '',
          last_name = '',
          email = '',
          phone_number: phone,
        } = this.$deepCopy(this.getTicketCart.customer_details);
        
        const country = this.$isNotEmptyV2(this.guest.country) ? this.guest.country : '';
        
        this.guest = { prefix, first_name, last_name, email, phone, country }
        setTimeout(() => {
          this.guestFormKey++
        }, 400);
      },
      async loadProductList(just_check = false) {
        try {
          const apiParams = {
            merchant_id: this.getMerchant.id,
            date_time: moment(this.visit_date.startDate).format("YYYY-MM-DD"),
            promo_code: this.promo_code.form
          }
          const { data: result } = await get("CORE", "ticket", apiParams);

          if (!result.success) throw new Error(result.message);
          if (!just_check) this.fillNewList(result.data);

          return result.data;
        } catch (err) {
          throw err;
        }
      },
      async loadProductSpecial() {
        try {
          this.product_special = {
            list: [],
            selected:{}
          }
          
          const { data: result } = await get("CORE", "product-special-option", { merchant_id: this.getMerchant.id });
          if (!result.success) throw new Error(result.message);

          
          const isQueryDomestic = this.$isNotEmptyV2(this.visitorType.selected) && this.visitorType.selected.id === 'domestic';
          if(isQueryDomestic){
            const domesticPrice = result.data.find(specialPrice => specialPrice.strict_guest_profile_country === 'Indonesia');
            this.toggleProductSpecial(domesticPrice);
            this.product_special.list.push(domesticPrice)
          }else{
            this.product_special.list = result.data.filter(specialPrice => this.$isEmpty(specialPrice.strict_guest_profile_country) || specialPrice.strict_guest_profile_country !== 'Indonesia');
            if(this.product_special.list.length === 1) this.toggleProductSpecial(this.product_special.list[0]);
          }
          
          
          return result.data;
        } catch (err) {
          throw err;
        }
      },
      async loadPaymentMethod() {
        try {
          this.payment_method.list = [];
          this.payment_method.is_load = true;

          this.$track('page_view', this.ticketTrackingProps, { pageType: 'payment' });
          
          const apiEndPoint = `merchant/${this.getMerchant.code}/payment-method`
          const { data: result } = await get("CORE_HOTEL", apiEndPoint, {module: 'ticket'});
          if (!result.success) throw new Error(result.message);
          
          this.payment_method.list = result.data.map(payment => {
                const { channel, pg_company } = payment;
                payment.payment_method = payment.channel
                payment.payment_channel = payment.channel
                payment.bank_name = payment.pg_company
                return payment;
              });
          return result.data;
        } catch (err) {
          throw err;
        } finally {
          this.payment_method.is_load = false;
        }
      },
      fillNewList(data, keep_qty = false) {
        const previousList = keep_qty ? this.$deepCopy(this.list) : []

        this.list = this.$deepCopy(data).map(product => {
          const prevProduct = previousList.find(p => p.id === product.id)
          const selectedId = this.product_special.selected.id

          return {
            ...product,
            variants: product.variants.map(variant => {
              const { id, product_special: specials = [] } = variant
              const defaultSpecial = specials[0]

              let id_cart = id
              let best_price = defaultSpecial
              let qty = 0

              if (keep_qty && prevProduct) {
                const prevVariant = prevProduct.variants.find(v => v.id === id)
                if (prevVariant) qty = prevVariant.qty
              }

              if (selectedId) {
                const special = specials.find(s => s.id === selectedId)
                if (special) {
                  id_cart = special.product_ticket_id
                  best_price = special
                }
              }

              return {
                ...variant,
                id_cart,
                qty,
                best_price
              }
            })
          }
        })
      },

      checkVisitorType(transactionDetail){
        const { product_special_used_list = null } = transactionDetail;
        if(this.$isEmpty(product_special_used_list)) return this.setVisitorTypeUrl("international");
        if(product_special_used_list[0].strict_guest_profile_country === 'Indonesia') return this.setVisitorTypeUrl("domestic");

        return this.setVisitorTypeUrl("international");
      },
      toggleProductDetail(data = {}){
        this.product_detail.show = !this.product_detail.show
        this.product_detail.data = data
        if(this.product_detail.show){
          this.$track('page_view', { ...this.ticketTrackingProps, item_id: data.id }, { pageType: 'product_detail' })
          let general_info_show = [data.product_detail,data.cancellation_policy,data.terms_conditions,data.how_to_redeem]
          let total_show = general_info_show.filter(x=>x)
          this.product_detail.show_collapse = total_show.length == 1
        }
      },
      changeQty(product_index,variant_index,action){
        let product_variant = this.list[product_index].variants[variant_index]
        if(!(action == 'minus' && product_variant.qty == 0)){
          if(action == 'plus' && product_variant.availability > product_variant.qty) this.list[product_index].variants[variant_index].qty++
          else if(action == 'minus') this.list[product_index].variants[variant_index].qty--
        }
      },
      removeQty(product){
        let product_index = this.list.findIndex(x=>x.id == product.id)
        if(product_index != -1){
          this.list[product_index].variants = this.list[product_index].variants.map(x=>{
            x.qty = 0
            return x
          })
        }
      },
      toggleProductSpecial(data = {}) {
        this.product_special.selected = data

        const hasSelection = Object.keys(data).length > 0

        this.list = this.list.map(product => {
          product.variants = product.variants.map(variant => {
            const { id, product_special: specials } = variant

            if (!hasSelection) {
              variant.id_cart = id
              variant.best_price = specials[0]
              this.guest.country = {}
              this.lock_form_guest.country = false
              return variant
            }

            const special = specials.find(ps => ps.id === data.id)

            if (special) {
              variant.id_cart = special.product_ticket_id
              variant.best_price = special
            } else {
              variant.id_cart = id
              variant.best_price = specials[0]
            }

            if (data.strict_guest_profile_country != null) {
              const country = this.country.find(c => c.name === data.strict_guest_profile_country)
              if (country) {
                this.guest.country = country
                this.lock_form_guest.country = true
              }
            }

            return variant
          })

          return product
        })
      },
      printVariantSelected(data){
        let return_data = ''
        data.pax.forEach((x,i)=>{
          return_data += `${x.qty} ${x.name}`
          if(i+1 < data.pax.length){
            return_data += ', '
          }
        })
        
        return_data += ` - ${this.$formatCurrency(data.best_price.best_price.final_price)} x ${data.qty}`
        
        return return_data
      },
      printTotalPriceSelected(data){
        let total = 0
        data.variants.forEach(x=>{
          total += (x.best_price.best_price.final_price*x.qty)
        })
        return this.$formatCurrency(total)
      },
      clearPromoCode(){
        this.promo_code.form = ''
        this.promo_code.error = ''
        if(this.promo_code.valid != ''){
          this.applyPromo()
        }else{
          this.promo_code.valid = ''
        }
      },
      applyPromo(){
        return new Promise((success,fail)=>{
          if(this.promo_code.form == '' && this.promo_code.valid == ''){
            this.promo_code.error = 'Promo code is empty'
            success()
          }else{
            this.$track('click', {
              ...this.ticketTrackingProps,
              promo_code: this.promo_code.form,
              label: 'Search Promocode'
            }, { pageType: 'cart' })
            this.promo_code.is_load = true
            this.promo_code.error = ''
            if(this.selected_product.length == 0) this.$smoothScroll('ticket-section')
            this.loadProductList(true)
            .then(res=>{
              this.fillNewList(res,true)
              this.promo_code.valid = this.promo_code.form
            })
            .catch(err=>{
              this.promo_code.error = err == 'promo_code not found' ? 'Promo code not available' : err
            })
            .finally(()=>{
              this.promo_code.is_load = false
              success()
            })
          }
        })
      },
      saveGuestData(field){
        const copiedGuest = this.$deepCopy(this.guest);
        const generateKey = () => {
          if (field === 'prefix') return 'title';
          else if (field === 'phone') return 'phone_number';
          return field
        }
        let params = {
          key: generateKey() ,
          value: copiedGuest[field]
        }
        
        this.ticketSetGuest({
          field: 'customer_details',
          data: [params]
        });
      },
      floatLabel(id,action){
        let el_container = document.getElementById(id);
        let el_input = el_container.querySelector('input')
        let el_label = null
        if(id == 'form_country' || id == 'form_title') {
          el_label = el_container.querySelector('.v-select-label')
          if(action == 'focus') el_label.classList.add('active');
          else if(action == 'blur') {
            let is_country_valid = id == 'form_country' && Object.keys(this.guest.country).length == 0
            let is_title_valid = id == 'form_title' && this.guest.prefix == ''
            if(is_country_valid || is_title_valid){
              el_label.classList.remove('active');
            }
          }
        }else{
          if(action == 'focus') el_container.classList.add('active');
          else if(action == 'blur' && el_input.value == '') {
            el_container.classList.remove('active');
          }
        }
      },
      validateForm(){
        return new Promise((success,fail)=>{
          const productWarning = this.selected_product.filter(product => product.variants.some(variant => this.$isNotEmptyV2(variant.message)));
          if(productWarning.length > 0){
            this.$smoothScroll("purchase-summary");
            setTimeout(() => {
              this.$root.$emit('bv::show::tooltip');
            }, 300);

            setTimeout(() => {
              this.$root.$emit('bv::hide::tooltip');
            }, 3300);

            fail()
          }
          
          let total_error = 0
          if(this.$v.guest.first_name.$invalid){
            total_error++
            this.validation.first_name = 'Please input your first name'
          }
          if(this.$v.guest.email.$invalid){
            total_error++
            if(!this.$v.guest.email.required) this.validation.email = 'Please input your email'
            else if(!this.$v.guest.email.email) this.validation.email = 'Invalid email'
          }
          this.validation.phone = ''
          if(this.$isNotEmptyV2(this.guest.phone)){
            const phone = this.guest.phone;
            var cleaned = phone.trim().replace(/[\s\-().]/g, '');
            
            if (cleaned.indexOf('+') !== 0) {
              total_error++
              this.validation.phone = 'Phone number must start with + and country dial code';
            }else{
              var parsed = parsePhoneNumberFromString(cleaned);
              if (!parsed || !parsed.isValid()) {
                total_error++
                this.validation.phone = 'Invalid international phone number format';
              }
            }
          }
          if(this.$v.guest.country.$invalid){
            total_error++
            this.validation.country = 'Please select your country'
          }

          if(total_error > 0) fail()
          else success()
        })
      },

      submitForm(){
        return new Promise((success,fail)=>{
          this.error_push = ''
          if(this.view_type == 1){
            this.validateForm()
            .then(()=>{
                this.$track('begin_checkout', this.ticketTrackingProps, { pageType: 'cart' })
                this.submitInquiry().finally(()=>success())
              })
              .catch(()=> fail())
          }else{
            this.$track('add_payment_info', this.ticketTrackingProps, { pageType: 'payment' })
            this.processPayment().finally(()=>success())
          }
        })
      },
      async submitInquiry(){
        try {
          const apiParams = this.getInquiryParams();
          const apiResponse = await post("CORE","tx-ticket-inquiry",apiParams);
          
          const { success, message, data } = apiResponse.data
          if(!success) throw new Error(message);
          
          this.$sendCustomTicketGTMDataLayer(data, "add_to_cart");
          if(this.total === 0){
            this.tx_inquiry = data
            this.processPayment().finally(() => success())
          }else{
            this.setTicketTransactionResult({field: 'inquiry', data: data});
            this.setTicketTransactionResult({field: 'selectedProduct', data: this.list});
            this.setTicketTransactionResult({field: 'promotion', data: this.promo_code});

            this.$router.push({
              name: 'TicketSelectPayment',
              query: {
                visitor_type: this.visitorTypeQuery
              }
            })
            success()
          }
          
        } catch (error) {
          this.error_push = error.message == 'invalid promo_code' ? 'This promo code is not valid for some tickets you have selected' : error.message
        }
        
      },
      getInquiryParams(){
        const { prefix, first_name, last_name, email, phone, country: { name : countryName }} = this.$deepCopy(this.guest);

        const guestData = {
          title: prefix,
          gender: prefix == 'MR' ? 'MALE' : 'FEMALE',
          country: countryName,
          phone_number: phone, 
          address: '', 
          first_name, 
          last_name, 
          email
        }

        let ticket_details = [];
        this.selected_product.forEach(product=>{
          product.variants.forEach(variant=>{
            ticket_details.push({ id: variant.id_cart, qty: variant.qty })
          })
        })
        
        return {
          merchant_id: this.getMerchant.id,
          visit_date: moment(this.visit_date.startDate).format("YYYY-MM-DD"),
          visitor_details: guestData,
          customer_details: guestData,
          promo_code: this.discount > 0 ? this.promo_code.form : '',
          ticket_details
        }
      },
      
      // STEP 2
      selectPayment(pm){
        this.payment_method.selected = pm
      },
      processPayment(){
        return new Promise((success,fail)=>{
          let data_payment = this.total === 0 ? {} : {
            id: this.payment_method.selected.id,
            payment_method: this.payment_method.selected.payment_method,
            bank_name: this.payment_method.selected.bank_name,
            payment_channel: this.payment_method.selected.payment_method
          }
          
          post("CORE","tx-ticket-payment",{
            tx_order_id:this.tx_inquiry.tx_order_id,
            payment_details: data_payment,
            promo_code: this.discount > 0 ? this.promo_code.form : '',
            ...resolveOrderTrackingFields(),
          }).then(response=>{
            let res = response.data
            if (res.success) {
              this.$sendCustomTicketGTMDataLayer(this.tx_inquiry, "begin_checkout");
              this.$track('purchase', {
                ...this.ticketTrackingProps,
                trx_id: this.tx_inquiry.tx_order_id
              }, { pageType: 'payment' })

              const urlQuery = this.$route.query;
              const pivotPaymentUrl = this.$isPivotPayment(this.payment_method.selected.bank_name) ? this.$getPivotPaymentUrl(res.payment) : '';
              if(this.total === 0){
                this.$router.push({
                  name: 'TicketPaymentComplete',
                  params:{
                    merchant_code: this.getMerchant.code,
                    tx_order_id : res.tx_order_id
                  },
                  query: {
                    visitor_type: this.visitorTypeQuery
                  }
                })
              }else if(pivotPaymentUrl){
                this.$openLink(pivotPaymentUrl)
                success()
              }else{
                this.$router.push({
                  name: 'TicketPaymentForm',
                  params:{
                    merchant_code: this.getMerchant.code,
                    tx_order_id : res.tx_order_id
                  },
                  query: {
                    visitor_type: this.visitorTypeQuery
                  }
                })
                success()
              }
            }else{
              this.error_push = res.message
              fail()
            }
          })
        })
        
      },

      // STEP 3
      downloadTicket(){
        return new Promise((success,fail)=>{
         setTimeout(()=>{
          success("DONE")
         }, 1000) 
        })
      },
    }
  }
</script> 
<style>
.visitor-type .title-item{
  font-size: 16px;
}
.visitor-type .subtitle-item{
  font-size: 12px !important;
  font-family: Nunito-SemiBold;
  color: #222222;
  letter-spacing: 0.25px;
}
@media screen and (min-width: 992px){
  .visitor-type .title-item{
    font-size: 20px;
  }
  .visitor-type .subtitle-item{
    font-size: 14px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/ticket/custom/Home.vue